import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ProvidersNav } from './ProvidersNav';

/** Shared section chrome for the Providers pages: container + title + nav. */
export function ProvidersShell({ children }: { children: ReactNode }) {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <Link
        to="/dev-console"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Dev Console
      </Link>
      <h1 className="text-2xl font-bold mb-4">Providers</h1>
      <ProvidersNav />
      {children}
    </div>
  );
}
